import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { MaskLine, Reveal, FadeIn, Overline } from "@/components/motion";
import { WA_URL } from "@/lib/site";
import { lenisRef } from "@/lib/lenis";

const GROUPS = [
  {
    id: "tempo",
    label: "Il tempo e l'ascolto",
    title: "«Ha dedicato tutto il tempo necessario»",
    intro:
      "È la cosa che i pazienti citano più spesso: nessuna fretta, e la sensazione di essere stati ascoltati fino in fondo.",
    reviews: [
      { text: "Molto esaustivo e competente a valutare un quadro completo dedicando tutto il tempo necessario al paziente. Trasmette tranquillità e mette a proprio agio.", by: "S.F.", prestazione: "Prima visita presso Synapses", date: "luglio 2026" },
      { text: "Dottore empatico, calmo, gentile e disponibile ad ascoltare le problematiche senza metter fretta ai pazienti. Molto chiaro nel prescrivere le cure e nelle spiegazioni.", by: "F.A.", prestazione: "Prima visita presso Synapses", date: "aprile 2026" },
      { text: "posso dire di essere rimasto estremamente soddisfatto. Ho trovato un professionista di grande competenza, capace di unire preparazione, attenzione e umanità in modo davvero raro. Ho apprezzato particolarmente la sua professionalità e la sua attenzione autentica verso il paziente: non si è limitato a una visita superficiale, ma ha dedicato tutto il tempo necessario per analizzare il problema e proporre un percorso adeguato.", by: "A.", prestazione: "Prima visita presso Synapses", date: "aprile 2026" },
      { text: "La visita è stata accurata, il dott. Cavallo mi è sembrato un medico attento, disponibile all'ascolto e preparato.", by: "M.F.", prestazione: "Prima visita presso Synapses", date: "marzo 2026" },
      { text: "Competente, professionale e disponibile all'ascolto del paziente", by: "A.C.", prestazione: "Prima visita", date: "agosto 2025" },
      { text: "Professionale attento preciso. Ha ascoltato ogni piccolo particolare. Diagnosi precisa. Molto attento.", by: "N.C.", prestazione: "Prima visita", date: "agosto 2021" },
      { text: "Dottore molto attento e accurato. Ascolta i problemi e segue nel dettaglio l'evolversi della situazione.", by: "B.A.R.", prestazione: "Visita di controllo", date: "giugno 2021" },
      { text: "Soddisfatta dell ascolto e la spiegazione molto professionali e gentili..per il mio dolore alla schiena e al collo mi ha chiesto un controllo dopo 4 mesi e chiedendomi bene i sintomi fin ora..", by: "J.", prestazione: "Prima visita", date: "aprile 2021" },
      { text: "Cordiale. dedicato all ascolto. Puntualità per orario visita. Lo consiglio per gentilizza e preparazione", by: "M.B.", prestazione: "", date: "novembre 2020" },
      { text: "Dottore Giovane ma preparato, ascolta il paziente, empatico con chi ha davanti, valuta la situazione clinica in modo attenta e precisa cercando di dare alle domande poste tutte le possibili spiegazioni.", by: "C.A.", prestazione: "Prima visita", date: "aprile 2021" },
      { text: "Medico molto attento a tutti i sintomi ricerca accurata di una cura giusta. Cordiale e gentile mette il paziente a suo agio", by: "M.", prestazione: "Visita neurologica", date: "giugno 2021" },
      { text: "Visita molto attenta e scrupolosa. Consigli preziosi per la cura e gestione delle problematiche legate alla patologia analizzata", by: "L.M.R.", prestazione: "Prima visita", date: "maggio 2021" },
      { text: "Mi sono trovata totalmente a mio agio per la cortesia e l'attenzione ai miei problemi.", by: "L.S.", prestazione: "Prima visita", date: "giugno 2022" },
      { text: "Mi sono trovata molto bene per la gentilezza e l'attenzione al paziente. La visita è stata molto accurata.", by: "A.S.", prestazione: "Prima visita", date: "giugno 2022" },
      { text: "Molto gentile e disponibile attento alle necessità del paziente", by: "A.S.", prestazione: "Prima visita", date: "giugno 2024" },
      { text: "il Dott. Enrico Cavallo ha un approccio con il paziente molto attento scrupoloso e professionale. Soddisfatta della visita", by: "E.C.", prestazione: "Prima visita", date: "ottobre 2022" },
    ],
  },
  {
    id: "spiegazioni",
    label: "Le spiegazioni",
    title: "«Spiegazioni chiare, anche quando il caso è complesso»",
    intro:
      "Capire cosa succede è spesso la prima cosa che manca a chi arriva. Queste recensioni raccontano com'è stata la spiegazione.",
    reviews: [
      { text: "prima visita neurologica dal Dott. Cavallo, ho avuto un ottima impressione di professionalità e di competenza.", by: "M.G.", prestazione: "Prima visita presso Synapses", date: "giugno 2026" },
      { text: "Molto Esaustivo e professionale nel descrivere il problema in atto", by: "F.G.", prestazione: "Elettromiografia", date: "maggio 2026" },
      { text: "Cortese e preparato. Ottima visita ha risposto a tutte le mie domande e fatta un ottima diagnosi. Già stabilito un prossimo incontro", by: "D.G.", prestazione: "Visita neurologica", date: "marzo 2026" },
      { text: "Mi sono trovata bene, cordiale e ha risposto a tutti i miei quesiti.", by: "S.", prestazione: "Elettromiografia", date: "febbraio 2026" },
      { text: "Bravi, attenti con spiegazione della visita e referto dettagliato.", by: "C.", prestazione: "Elettromiografia", date: "gennaio 2026" },
      { text: "Visita medica fatta nel dettaglio.Ottimo neurologo consigliato!!!", by: "E.P.", prestazione: "Visita neurologica", date: "gennaio 2026" },
      { text: "Molto attento alle sintomatologie descritte, spiegazioni esaurienti, per l'efficacia della terapia vedremo", by: "T.", prestazione: "Visita neurologica", date: "novembre 2025" },
      { text: "TUTTO BENE VISITA IN ORARIO VISITA MOLTO DETTAGLIATA SPIEGAZIONE MOLTO CHIARA", by: "B.G.", prestazione: "Elettromiografia", date: "maggio 2025" },
      { text: "Risposte chiare e sofisticate alle mie richieste a riguardo delle mie problematiche. Ottimo", by: "C.L.V.", prestazione: "", date: "febbraio 2025" },
      { text: "Medico di grande competenza, ed umanità. Scrupoloso nell'esecuzione dell'esame, chiaro e disponibile nel dare spiegazioni a conclusione.", by: "A.G.", prestazione: "Elettromiografia", date: "gennaio 2025" },
      { text: "Medico molto preciso nelle spiegazioni del caso, mette a proprio agio e di massima disponibilità. Grazie", by: "S.", prestazione: "", date: "aprile 2024" },
      { text: "Medico cortese e competente ha risposto a tutte le mie domande in modo molto professionale.", by: "C.R.", prestazione: "Elettromiografia", date: "gennaio 2022" },
      { text: "Mi sono trovata bene, medico disponibile e molto cortese. Non si perde in chiacchiere, anzi, arriva al punto, ma sempre con delicatezza.", by: "D.D.S.", prestazione: "Prima visita", date: "agosto 2021" },
    ],
  },
  {
    id: "esame",
    label: "Prima e durante un esame",
    title: "«Mi ha messo a mio agio prima dell'esame»",
    intro:
      "La paura dell'elettromiografia è una delle ragioni per cui molti rimandano. Ecco come l'hanno vissuta i pazienti.",
    reviews: [
      { text: "Dottore molto professionale, delicato durante l'esame e ottimo studio. Ha saputo calmarmi durante l'EMG per la mia paura degli aghi. Molto gentile", by: "G.C.", prestazione: "Elettromiografia", date: "settembre 2026" },
      { text: "Molto gentile e professionale. Tornerò sicuramente da lui per il prossimo controllo", by: "K.S.", prestazione: "Elettromiografia", date: "settembre 2026" },
      { text: "Serio , professionale ,competente condomade pertinenti.", by: "G.V.", prestazione: "Elettromiografia", date: "settembre 2026" },
      { text: "Competente, scrupoloso, gentile. Ha svolto un esame approfondito. Sono soddisfatta", by: "G.M.", prestazione: "Elettromiografia", date: "febbraio 2026" },
      { text: "Ottimo specialista che ha valutato accuratamente il mio problema.", by: "A.", prestazione: "Elettromiografia", date: "febbraio 2026" },
      { text: "Ottimo! Consiglio il dottore, bravo e preciso. Mi ha messo subito a mio agio", by: "C.", prestazione: "Prima visita presso Synapses", date: "marzo 2025" },
      { text: "Efficienti e veloci con quel po' di empatia che rsserena il paziente", by: "A.F.", prestazione: "Elettromiografia", date: "febbraio 2025" },
      { text: "Condivido le recensioni positive,ha effettuato l esame in maniera meticolosa trovando subito quello che non andava , professionale e gentile , grazie", by: "L.M.", prestazione: "Elettromiografia", date: "novembre 2024" },
      { text: "Puntuale e professionale nell'esecuzione dell'elettromiografia e nella spiegazione del referto.", by: "K.", prestazione: "Elettromiografia", date: "marzo 2022" },
      { text: "Effettuato elettromiografia con il Dott. Cavallo e devo dire che è stato molto scrupoloso sapendo il fatto suo, lo consiglio.", by: "B.", prestazione: "Elettromiografia", date: "maggio 2021" },
      { text: "Gentile, grarbato, attento, estremamente sensibile e rispettoso nei confronti della paziente anziana e un po' in ansia. […] Studio medico piccino, ma pulitissimo, ordinato e ben organizzato con reception e personale molto disponibile.", by: "M.J.", prestazione: "Prima visita", date: "maggio 2021" },
      { text: "Fatta la mia prima visita oggi ...professionale attento ...mi ha dato fiducia e tranquillità sono uscita dallo studio più serena nonostante debba fare degli accertamenti mi ha trasmesso sicurezza..mi sono sentita capita e ascoltata ! Ha eseguito tutto i test !", by: "M.", prestazione: "Prima visita", date: "agosto 2021" },
      { text: "Elettromiografia fatta dal dottor cavallo e staff soddisfacente", by: "F.V.", prestazione: "Elettromiografia", date: "aprile 2025" },
    ],
  },
  {
    id: "caso",
    label: "Il caso difficile",
    title: "«Anche quando la diagnosi non era semplice»",
    intro: "Molti arrivano dopo mesi senza risposte. Sono le recensioni di chi aveva un quadro complicato.",
    reviews: [
      { text: "Il Dott. Cavallo è estremamente competente e attento ai dettagli. Ha esaminato il mio caso senza pregiudizi, anche di fronte a una condizione rara in età giovane. Un vero professionista, affidabile e serio.", by: "F.I.", prestazione: "Prima visita", date: "febbraio 2025" },
      { text: "Consiglio vivamente il Dottor Cavallo,a chi avesse bisogno di una valutazione neurologica. Personalmente mi è stata fatta una visita accurata, considerando il quesito diagnostico complicato.", by: "E.", prestazione: "Prima visita", date: "giugno 2021" },
      { text: "Serietà e approfondimento del problema, valutazione accurata", by: "G.R.", prestazione: "", date: "maggio 2025" },
      { text: "Attenzione e competenza hanno contraddistinto la consulenza da me richiesta.", by: "M.M.", prestazione: "", date: "gennaio 2025" },
      { text: "Molto competente, scrupoloso, attento ed empatico. Ottima scelta.", by: "M.E.D.G.", prestazione: "Prima visita presso Synapses", date: "febbraio 2026" },
      { text: "secondo la mia esperienza, non potevo trovare di meglio perché è molto disponibile, professionale e mi fa sentire a mio agio. lo consiglio a tutti.", by: "T.C.", prestazione: "Prima visita presso Synapses", date: "febbraio 2026" },
      { text: "Molto professionale. Ti mette a tuo agio .Mi sono trovata molto bene.graziel", by: "L.C.", prestazione: "Prima visita presso Synapses", date: "settembre 2025" },
    ],
  },
  {
    id: "puntualita",
    label: "Puntualità e organizzazione",
    title: "«Visita in orario, referto dettagliato»",
    intro: "Tempi rispettati e referti consegnati come promesso.",
    reviews: [
      { text: "Puntualità, cortesia e professionalità. Dopo una visita accurata è stato redatto un referto dettagliato.", by: "M.Z.", prestazione: "Prima visita", date: "novembre 2022" },
      { text: "Puntualità e disponibilità, è la prima visita neurologica che ho fatto", by: "Z.L.", prestazione: "Prima visita", date: "luglio 2023" },
      { text: "Il dottor Cavallo è stato molto puntuale, gentile, scrupoloso e chiaro durante la visita specialistica.", by: "A.", prestazione: "Prima visita", date: "novembre 2020" },
      { text: "Vengo dalla Liguria, ho trovato nel giovane dott.Cavallo un ottimo professionista, serio, scrupoloso e preparato.Cordiale e sensibile mi ha messo a mio agio, dando spiegazioni dettagliate al mio problema.Puntualità e buona accoglienza in studio.", by: "R.B.", prestazione: "Visita di controllo", date: "febbraio 2021" },
      { text: "Accogliente.preparatissimo.scrupoloso.gentilissimo.consigliato per tutti i problemi neurologici.un grazie anche al personale di segreteria.gentilissimi.", by: "M.", prestazione: "Elettromiografia", date: "settembre 2021" },
      { text: "Professionalità e gentilezza, mi sono sentita seguita con grande competenza.Mi sono trovata bene,corrispondente alle mie aspettative.", by: "G.", prestazione: "Elettromiografia", date: "febbraio 2022" },
      { text: "Ottimo servizio, professionali grazie mille del servizio", by: "G.P.R.", prestazione: "Elettromiografia", date: "giugno 2026" },
    ],
  },
];

const IN_BREVE = [
  { text: "Gentilissimo e super professionale. Consigliato top", by: "S." },
  { text: "Molto bravo in tutto qperuello che ha fatto per me non mi aspettavo", by: "T.A." },
  { text: "Dott.molto professionale, ti mette a tuo agio e di estrema cordialità", by: "D.V." },
  { text: "Ho trovato il dottore molto gentile e professionale", by: "D.S.D." },
  { text: "Lo specialista competente persona empatica molto bene", by: "S.T." },
  { text: "L'esame soddisfacente è il medico molto preparato", by: "F.S.M." },
  { text: "Molto attento alla problematica presentata . Mette a proprio agio . Consigliato", by: "Paziente" },
  { text: "Ho fatto una prima visita neurologica dal dr Cavallo. Il dottore è stato molto disponibile e preparato. Ottima esperienza", by: "A." },
  { text: "Bravo premuroso professionale ti mette a tuo agio esaustivo lo consiglio vivamente", by: "L." },
  { text: "Abbiamo avuto la prima visita neurologica ieri e siamo rimasti molto soddisfatti per accuratezza cortesia e chiarezza del Dottore", by: "P.L." },
  { text: "Essendo la prima visita posso dire che è andata bene, vedremo per le prossime...", by: "C.G." },
  { text: "BUONGIORNO MIO MARITO HA FATTO LA PRIMA VISITA OGGI DAL DOTT CAVALLO E ' RIMASTO MOLTO SODDISFATTO DELLA VISITA ,MEDICO CHE TI METTE A TUO AGIO E MOLTO ATTENTO ALLE PROBLEMATICHE DEL PAZIENTE .COMPLIMENTI SE NE TROVANO POCHI AI GIORNI D'OGGI .GRAZIE SALUTI.", by: "C.C." },
];

function scrollToGroup(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -96 });
  else el.scrollIntoView({ block: "start" });
}

function ReviewCard({ r, light }) {
  const meta = [r.by, r.prestazione, r.date].filter(Boolean).join(" · ");
  return (
    <blockquote
      className={`rounded-lg border p-7 h-full flex flex-col min-w-0 break-words ${
        light ? "bg-crema border-ink/5" : "bg-crema-warm border-ink/5"
      }`}
    >
      <p className="text-ink/85 leading-relaxed text-[17px] md:text-lg">«{r.text}»</p>
      <footer className="mt-5 text-sm text-viole">{meta}</footer>
    </blockquote>
  );
}

function Group({ g, index }) {
  const light = index % 2 === 1;
  return (
    <section
      id={g.id}
      className={`${light ? "bg-crema-warm" : "bg-crema"} py-20 lg:py-28 scroll-mt-24`}
      data-testid={`group-${g.id}`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <h2 className="font-sora font-bold tracking-tighter text-3xl md:text-4xl text-ink max-w-3xl">
            {g.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-viole text-lg leading-relaxed max-w-2xl">{g.intro}</p>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {g.reviews.map((r, i) => (
            <Reveal key={i} delay={0.04 * (i % 4)}>
              <ReviewCard r={r} light={!light} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Recensioni() {
  return (
    <>
      <section className="bg-indaco-deep text-crema pt-40 pb-20 lg:pt-52 lg:pb-24 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <div className="absolute -right-40 -top-10 w-[420px] h-[420px] rounded-full border border-crema/10" />
          <div className="absolute -right-16 top-24 w-[420px] h-[420px] rounded-full border border-arancio/20" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <FadeIn>
            <Overline light>Recensioni</Overline>
          </FadeIn>
          <h1 className="mt-8 font-sora font-extrabold tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-[1.05]" data-testid="recensioni-title">
            <MaskLine delay={0.15}>I pazienti raccontano</MaskLine>
            <MaskLine delay={0.3}>
              com'è stata <span className="text-arancio">la loro visita.</span>
            </MaskLine>
          </h1>
          <FadeIn delay={0.6}>
            <p className="mt-8 max-w-2xl text-crema/70 text-lg leading-relaxed">
              Una selezione delle 81 recensioni verificate del Dott. Enrico Cavallo su MioDottore,
              raccolte a Synapses e nelle altre strutture in cui lavora. Nessuna è stata modificata:
              le trovi con la data e il tipo di prestazione.
            </p>
          </FadeIn>
          <FadeIn delay={0.75}>
            <p className="mt-8 text-[15px] md:text-base text-crema/80 flex flex-wrap items-center gap-x-1.5" data-testid="recensioni-score">
              5,0 <span className="text-arancio text-[17px] md:text-lg leading-none" aria-hidden="true">★</span> su MioDottore · 81 recensioni verificate
            </p>
            <p className="mt-3 text-sm text-crema/70 max-w-xl">
              MioDottore verifica ogni recensione e non permette ai medici di rimuoverle o modificarle.
            </p>
          </FadeIn>
        </div>
      </section>

      <nav className="bg-crema border-b border-ink/10 py-6 sticky top-20 z-30" data-testid="recensioni-nav">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap gap-3">
          {GROUPS.map((g) => (
            <button
              key={g.id}
              onClick={() => scrollToGroup(g.id)}
              className="rounded-full border border-ink/15 px-5 py-2.5 text-sm md:text-[15px] md:text-base font-medium text-ink/80 transition-colors duration-300 hover:border-indaco hover:text-indaco"
              data-testid={`nav-group-${g.id}`}
            >
              {g.label}
            </button>
          ))}
        </div>
      </nav>

      {GROUPS.map((g, i) => (
        <Group key={g.id} g={g} index={i} />
      ))}

      <section className="bg-crema-warm py-20 lg:py-28" data-testid="in-breve">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <Overline>In breve</Overline>
          </Reveal>
          <div className="mt-10 grid md:grid-cols-3 gap-4">
            {IN_BREVE.map((r, i) => (
              <Reveal key={i} delay={0.03 * (i % 3)}>
                <div className="bg-crema rounded-lg border border-ink/5 p-6 h-full flex flex-col min-w-0 break-words">
                  <p className="text-ink/85 leading-relaxed text-[15px] md:text-base">«{r.text}»</p>
                  <p className="mt-4 text-sm text-viole">— {r.by}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-indaco-deep text-crema py-24 lg:py-32" data-testid="recensioni-cta">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <Reveal>
            <h2 className="font-sora font-bold tracking-tighter text-3xl md:text-5xl">
              La prossima recensione potrebbe essere la tua.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-crema/70 text-lg">
              Raccontaci cosa ti succede. Ti rispondiamo noi entro 24 ore, senza impegno.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <Link
                to="/prenota"
                className="group inline-flex items-center gap-3 rounded-full bg-crema px-8 py-4 text-[15px] md:text-base font-semibold text-ink transition-colors duration-300 hover:bg-arancio hover:text-crema"
                data-testid="recensioni-cta-prenota"
              >
                Richiedi un appuntamento →
              </Link>
              <a
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 rounded-full border border-crema/30 px-8 py-4 text-[15px] md:text-base font-semibold text-crema transition-colors duration-300 hover:border-crema"
                data-testid="recensioni-cta-whatsapp"
              >
                <MessageCircle className="w-4 h-4" />
                Chiedi su WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
